export const PATHS = {
  login: "/",
  recoverPassword: "/recover-password",
  eBanking: "/menu",
  accounts: "/menu/accounts",
  accountDetails: "/menu/accounts/details",
  movements: "/menu/accounts/details/movements",
  transfers: "/menu/accounts/details/transfers",
  customerRegistration: "/menu/customer-registration",
  legalEntity: "/menu/customer-registration/legal-entity",
  naturalPerson: "/menu/customer-registration/natural-person",
};

const API_KUBITQ = `${process.env.REACT_APP_API_BASE_KUBITQ}${process.env.REACT_APP_API_BASE_URL}`;

export const URL_API = {
  AUTH_LOGIN: `${API_KUBITQ}/auth/login`,
  AUTH_LOGOUT: `${API_KUBITQ}/auth/logout`,
  AUTH_ENROLL: `${API_KUBITQ}/auth/2fa/enroll`,
  AUTH_ROLES: `${API_KUBITQ}/auth/roles`,
  AUTH_PROFILES: `${API_KUBITQ}/auth/profiles`,
  AUTH_AUTHUSER: `${API_KUBITQ}/auth/users/authuser`,
  ACCOUNTS_CUSTOMERS: `${API_KUBITQ}/accounts/customers`,
  ACCOUNTS_MOVEMENTS_LATEST: `${API_KUBITQ}/accounts/#/movements/latest`,
  ACCOUNTS_MOVEMENTS_PAGED: `${API_KUBITQ}/accounts/#/movements/paged`,
  SPEI_SEND: `${API_KUBITQ}/spei`,
  SPEI_BANKS: `${API_KUBITQ}/spei/banks`,
  SPEI_ACCOUNT: `${API_KUBITQ}/spei/account-types`,
  SPEI_PAYMENT: `${API_KUBITQ}/spei/payment-types`,
  TRANSFERS_SEND: `${API_KUBITQ}/transfers`,
  PARTNERS: `${API_KUBITQ}/partners`,
  CUSTOMERS: `${API_KUBITQ}/customers`,
};

export const MENUS = {
  LOGIN: 1,
  CUSTOMER_REGISTRATION: 2,
  ACCOUNTS: 3,
  HOME: 4,
};
/**
Menus backup
{
            name: 'Inicio',
            icon: 'home',
        },
        {
            name: 'Banca',
            icon: 'briefcase',
            suboptions: [
                { name: 'Mis clientes', icon: 'personal-card' },
                { name: 'Mis cuentas', icon: 'profile-2users' submenu: MENUS.CUSTOMER_REGISTRATION},
            ],
        },
        {
            name: 'Centro de ayuda',
            icon: 'help',
        },
 */

export const itemsSidenav = {
  options: [
    {
      name: "Inicio",
      icon: "home",
      menu: MENUS.HOME,
    },
    {
      name: "Banca",
      icon: "briefcase",
      suboptions: [
        {
          name: "Mis cuentas",
          icon: "profile2users",
          submenu: MENUS.ACCOUNTS,
        },
      ],
    },
    {
      name: "Cerrar Sesión",
      icon: "logout",
      menu: MENUS.LOGIN,
    },
  ],
};

export const ACCOUNT_DETAILS_OPTIONS = [
  { name: "Movimientos", icon: "movements", page: PATHS.movements },
  { name: "Transferir", icon: "wallet", page: PATHS.transfers },
];

export const TRANSFER_TAB = {
  TRANSFER: "Transfer",
  PENDING: "Pending",
  TRACKING: "Traking",
  FAVS: "Favs",
  BULK_TRANSFER: "BulkTransfer",
};
export const TRANSFERS_OPTIONS = [
  { name: "Transferencia", icon: "NA", page: TRANSFER_TAB.TRANSFER },
  { name: "Transferencias Masivas", icon: "NA", page: TRANSFER_TAB.BULK_TRANSFER },
  { name: "Transferencias Pendientes", icon: "NA", page: TRANSFER_TAB.PENDING },
  {
    name: "Seguimiento Transferencias",
    icon: "NA",
    page: TRANSFER_TAB.TRACKING,
  },
  { name: "Favoritos", icon: "NA", page: TRANSFER_TAB.FAVS },
];

export const MOVEMENTS_TYPE = {
  1: "SpeiOut",
  2: "SpeiIn",
  3: "Traspaso",
};

export const MARKETPLACE_OPTIONS = [
  { label: "Pago de servicios ", icon: "receipt" },
  { label: "Market place", icon: "shop" },
  { label: "Carga de tiempo aire", icon: "cards" },
  { label: "Tarjetas de regalo", icon: "gift" },
];

export const LEGAL_ENTITY_FILES = {
  1: "Acta Constitutiva",
  2: "Constancia de Situación Fiscal",
  3: "Registro Publico del Comercio",
  4: "Comprobante de Domicilio con antigüedad no mayor a 3 meses",
  5: "Teléfono de Oficina",
  6: "Fotografías de Fachada e Interior de las oficinas. En caso de que aplique",
  7: "Poder del Representante Legal",
  8: "Identificación Oficial Vigente del Representante Legal",
  9: "Comprobante de Domicilio del Representante Legal",
  10: "Constancia de Situación Fiscal del Representante Legal",
  11: "Identificación Oficial de los miembros del Consejo de Administración",
  12: "Comprobante de domicilio de los miembros del Consejo de Administración",
  13: "Teléfonos de contacto de Representante Legal y Miembros del Consejo de Administración",
  14: "Correo electrónico de Representante Legal y Miembros del Consejo de Administración",
};

export const NATURAL_PERSON_FILES = {
  1: "ID Oficial de INE",
  2: "Pasaporte",
  3: "Comprobante de domicilio",
  4: "Constancia de Situación Fiscal",
  5: "Otro (Especifique)",
};

export const ROLES = {
  ROOT: 1,
};

export const CUSTOMER_TYPE = {
  PARTNER: 1,
  CLIENT: 2,
};

export const PROFILE_TYPE = {
  GOOD: 1,
  CLIENT: 2,
};

export const SESSION_TOKEN_KEY = "kubitq-token";
export const SESSION_CUSTOMER_KEY = "kubitq-customer";
export const SESSION_PROFILE_KEY = "kubitq-profile";

export const APP_NAME = process.env.REACT_APP_NAME || 'masefe'

export const APP_TEXTS = ({
  masefe: {
    copyrightName: 'mas.efe',
    copyrightYear: '2024',
    displayName: 'MASEFE',
    transferName: '+EFE'
  },
  livingrock: {
    copyrightName: 'LivingRock',
    copyrightYear: '2024',
    displayName: 'LivingRock',
    transferName: 'LivingRock'
  }
})[APP_NAME]


export const CUSTOM_SIDENAV_STYLE= ({
  masefe: {
    classes: ['bg-gradient-to-b', 'from-primary', 'to-neutral-5', 'text-white', 'stroke-white'],
    img: '/img/masefe-bg-sidebar.png',
    iconClasses: [],
    subMenuClasess: ['bg-transparent', '[&.selected]:stroke-white', '[&.selected]:fill-white','[&.selected]:border-b-2','[&.selected]:border-b-tertiary', ['pl-12']],
    menuClasses: ['bg-transparent'],
    subMenuContainerClasses: ['bg-primary', 'bg-opacity-20']
  },
  livingrock: {classes:['bg-white', 'text-neutral-5'],
    iconClasses: ['stroke-neutral-5','[&.selected]:stroke-black'],
    subMenuClasess: ['bg-neutral-1'],
    menuClasses: [],
    subMenuContainerClasses: ['bg-neutral-1']
  }
})[APP_NAME]